import { defineComponent as i, getCurrentInstance as l, h as s, createSSRApp as y } from "vue";
import { defineStore as p, createPinia as m } from "@sunrise/pinia";
const d = p("hydration", {
  state: () => ({})
});
let f = 0;
const b = i({
  props: {
    name: {
      type: String,
      required: !0
    }
  },
  setup({ name: t }) {
    var a, c, u;
    const e = l(), o = (u = (a = e == null ? void 0 : e.proxy) == null ? void 0 : (c = a.$slots).default) == null ? void 0 : u.call(c), n = t + ++f + "hydration";
    return d().$patch({
      // @ts-ignore
      [n]: o[0].props
    }), o ? () => s(
      "div",
      {
        "data-hydration": t,
        "data-cms-id": n
      },
      [s(o[0])]
    ) : (console.error("No component to hydrate"), () => s("div", ["No component to hydrate"]));
  }
});
function w(t) {
  const e = document.querySelectorAll("[data-hydration]"), o = v();
  return e.forEach(async (n) => h(n, t, o)), o;
}
async function h(t, e, o) {
  const n = t.dataset.hydration;
  if (!n)
    return;
  const r = await C(n, e);
  return S(r, t, o);
}
function S(t, e, o) {
  const r = d(o).$state[e.dataset.cmsId], a = y(t, {
    ...r
  });
  a.use(o), a.mount(e);
}
async function C(t, e) {
  return e[t];
}
function v() {
  const t = m();
  return t.state.value = window.__pinia__, g(t), t;
}
function g(t) {
  var e, o, n, r;
  (r = (n = (o = (e = t == null ? void 0 : t.state) == null ? void 0 : e.value) == null ? void 0 : o.globalState) == null ? void 0 : n.requestContext) != null && r.url && (t.state.value.globalState.requestContext.url = new URL(t.state.value.globalState.requestContext.url));
}
export {
  b as MsHydration,
  w as hydrate,
  d as useHydrationStore
};
